import React, { Component } from "react";

import "./publication.scss";

export default class Publication extends Component {
  onClick = e => {
    this.props.onClick && this.props.onClick(e);
  };
  render() {
    const { publication } = this.props;
    return (
      <div className="publication-item" onClick={this.onClick}>
        <div className="m-1">
          <img
            src={publication.publication_number.cover_url}
            alt={publication.name}
            className="img img-fluid rounded"
            style={{ maxWidth: 150 }}
          />
        </div>
      </div>
    );
  }
}
